/* About page — refined luxury reveal (slow fade + rise). Self-contained, reduced-motion & no-JS safe. */
(function () {
  'use strict';
  function reveal(root) {
    var els = (root || document).querySelectorAll('.about-reveal:not([data-revealed])');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-revealed', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); e.target.setAttribute('data-revealed', ''); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reveal(); });
  else reveal();
  document.addEventListener('shopify:section:load', function (e) { setTimeout(function () { reveal(e.target || document); }, 50); });
})();
